import React, { FC, memo, useEffect, useState } from 'react';
import styles from '@/styles/components/popup-banner.module.scss';
import LazyImage from '@/components/common/lazy-image';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import Image from 'next/image';

type Props = {
  className?: string;
  popupBanner: any;
};

const PopupBanner: FC<Props> = memo(props => {
  const { popupBanner } = props;
  const [isClosedPopup, setIsClosedPopup] = useState(true);
  const [isDisplayPopup, setIsDisplayPopup] = useState(false);

  const desktopImageUrl =
    (popupBanner?.displayContent?.length && popupBanner?.displayContent[0]?.desktop_image?.url) ||
    '';
  const mobileImageUrl =
    (popupBanner?.displayContent?.length && popupBanner?.displayContent[0]?.mobile_image?.url) ||
    '';
  const redirectUrl =
    (popupBanner?.displayContent?.length && popupBanner?.displayContent[0]?.url_redirection) || '';
  const openInNewTab =
    popupBanner?.displayContent?.length && popupBanner?.displayContent[0]?.open_in_new_tab;

  useEffect(() => {
    const isClosedFromCookie = Cookies.get('__Host-isClosedPopup');
    setIsClosedPopup(isClosedFromCookie === 'true');
    const startDateData = popupBanner?.start_date || '';
    const endDateData = popupBanner?.end_date || '';
    const startDate: any = startDateData ? new Date(startDateData) : null;
    const endDate: any = endDateData ? new Date(endDateData) : null;
    const currentDate = new Date();
    if (startDateData && !endDateData) {
      setIsDisplayPopup(currentDate >= startDate);
    } else if (!startDateData && endDateData) {
      setIsDisplayPopup(currentDate <= endDate);
    } else if (startDateData && endDateData) {
      setIsDisplayPopup(currentDate >= startDate && currentDate <= endDate);
    } else if (!startDateData && !endDateData) {
      setIsDisplayPopup(true);
    }
  }, []);

  const handleClose = () => {
    setIsClosedPopup(true);
    Cookies.set('__Host-isClosedPopup', 'true', { sameSite: 'strict', secure: true });
  };

  const handleSendGA = () => {
    window?.dataLayer?.push({
      event: 'buttonClick',
      buttonTitle: 'blog_banner_cta',
      description: '',
      destinationUrl: redirectUrl,
      pageURL: window.location.href,
      componentName: 'pop banner'
    });
  };
  if (isClosedPopup) {
    return null;
  }

  return (
    <div
      className={classNames(styles.Popup_Banner_Display, {
        [styles.Is_Display]: isDisplayPopup && !isClosedPopup && popupBanner?.displayContent?.length
      })}
    >
      <div className={styles.Popup_Banner}>
        <div className={styles.Banner_Container}>
          <div className={styles.Banner_Pc}>
            {
              <a
                href={redirectUrl}
                target={openInNewTab ? '_blank' : ''}
                onClick={() => handleSendGA()}
              >
                <div className={styles.Image_Wrapper}>
                  <LazyImage
                    className={styles.Image_Pc}
                    src={desktopImageUrl}
                    alt="Popup_Banner_Pc"
                    height={'100%'}
                    width={'100%'}
                  />
                </div>
              </a>
            }
            <div className={styles.Close_Button} onClick={handleClose}>
              <Image src="/blog/icon/Close.svg" alt={''} width={13} height={12} />
            </div>
          </div>

          <div className={styles.Banner_Mobile}>
            {
              <a
                href={redirectUrl}
                target={openInNewTab ? '_blank' : ''}
                onClick={() => handleSendGA()}
              >
                <div className={styles.Image_Wrapper}>
                  <LazyImage src={mobileImageUrl} alt="Popup_Banner_Mobile" />
                </div>
              </a>
            }
            <div className={styles.Close_Button} onClick={handleClose}>
              <Image src="/blog/icon/Close.svg" alt={''} width={13} height={12} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
export default PopupBanner;
